import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import {
  fallbackLanguage,
  resources,
  supportedLanguages,
  type SupportedLanguage,
} from './resources'

export const languageStorageKey = 'aihub_language'
const legacyLanguageStorageKey = 'aiportal_language'

/**
 * 将浏览器和 i18next 可能返回的语言变体映射到实际资源 key。
 * 这样即使 i18next 返回 `en`，语言切换控件也能稳定命中 `en-US`。
 */
export function normalizeLanguage(language?: string): SupportedLanguage {
  const normalizedLanguage = language?.toLowerCase()

  if (normalizedLanguage?.startsWith('en')) {
    return 'en-US'
  }

  if (normalizedLanguage?.startsWith('zh')) {
    return 'zh-Hans'
  }

  return fallbackLanguage
}

function getStoredLanguage(): SupportedLanguage {
  if (typeof window === 'undefined') {
    return fallbackLanguage
  }

  return normalizeLanguage(
    window.localStorage.getItem(languageStorageKey) ??
      window.localStorage.getItem(legacyLanguageStorageKey) ??
      undefined,
  )
}

void i18n.use(initReactI18next).init({
  fallbackLng: fallbackLanguage,
  interpolation: {
    escapeValue: false,
  },
  lng: getStoredLanguage(),
  ns: ['auth', 'shell'],
  resources,
  supportedLngs: supportedLanguages,
})

/**
 * 切换 i18next 前先持久化语言选择，刷新后无需等待应用状态恢复也能沿用同一语言。
 */
export function setAppLanguage(language: SupportedLanguage) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(languageStorageKey, language)
    window.localStorage.removeItem(legacyLanguageStorageKey)
  }

  return i18n.changeLanguage(language)
}

export { supportedLanguages }
export type { SupportedLanguage }
export default i18n
